<template>
  <q-page>
  <div class="panel wraper panel-gray" :class="{'panel-canceled':tempCase.canceled}">
    <div class="panel-header">
      <div class="panel-title">
        <unit-path v-once :id="iniCase.parent_id" :lbl="lbl"></unit-path>
      </div>
    </div>
    <div class="panel-body" id="formbody">
      <request-card v-once v-if="request" :request="request"></request-card>
      <q-field
         :error="$v.tempCase.problem.$error"
         :error-label="$v.tempCase.problem | errorLabel"
      >
        <q-input
            type="textarea"
            :rows="1"
            v-model.trim="tempCase.problem"
            :autofocus="true"
            float-label="Проблема"
        />
      </q-field>
      <q-field
         :error="$v.tempCase.master.$error"
         :error-label="$v.tempCase.master | errorLabel"
      >
        <q-select
          float-label="Исполнитель"
          v-model="tempCase.master"
          :options="$store.getters.engineers"
          :disable="!isDispatcher"
        />
      </q-field>
      <q-field
        :error="$v.tempCase.result.$error"
        :error-label="$v.tempCase.result | errorLabel"
      >
        <q-input
            float-label="Результат"
            type="textarea"
            :rows="1" v-model.trim="tempCase.result" />
      </q-field>
      <q-checkbox class="q-mt-md q-mb-md" v-model="tempCase.canceled" label="Отменен" />
      <p class="text-bolder">Работы ({{tempWorks.length}})
        <q-btn
            @click="doAdd"
            :disabled="addDisabled"
            title="Добавить работу"
            round
            small
            color="secondary"
            icon="add"
        />
      </p>
      <div class="panel-list">
        <transition-group tag="div" name="mylist">
          <div
              class="panel"
              :class="$utils.statusClass(work.completed?3:1, work.msDate)"
              v-for="(work, index) in tempWorks"
              :key="work.key">
            <div class="panel-body">
              <q-btn
                  round
                  outline
                  small
                  color="negative"
                  icon="delete_forever"
                  class="pull-right"
                  @click="removeWork(index)"
                  title="Удалить работу"
              />
              <q-field>
                <div class="row group">
                  <q-checkbox
                      :class="!work.date?'':work.completed?'text-positive':'text-primary'"
                      v-model="work.completed"
                      :disable="!work.date"
                      :keep-color="!!work.date"
                      :color="work.completed?'positive':'primary'"
                      :unchecked-icon="!!work.date?'build':'hourglass_empty'"
                      checked-icon="done"
                      :label="!work.date?'Отложена':work.completed?'Выполнена':'Запланирована'"
                  />
                  <q-datetime
                      placeholder="Введите дату"
                      clearable
                      popover
                      v-model="work.date"
                      :first-day-of-week="1"
                      format="DD.MM.YYYY"
                  />
                </div>
              </q-field>
              <q-field
                       :error="$v.tempWorks.$each[index].task.$error"
                       :error-label="$v.tempWorks.$each[index].task | errorLabel"
              >
                <q-input float-label="Задача"
                         type="textarea"
                         :rows="1" v-model.trim="work.task" />
              </q-field>
              <q-field
                       :error="$v.tempWorks.$each[index].short.$error"
                       :error-label="$v.tempWorks.$each[index].short | errorLabel"
              >
                <q-input float-label="Сделано" type="textarea"
                         :rows="1" v-model.trim="work.short" />
              </q-field>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <save-btn :notChanged="notChanged" :goView="goView" :doSave="doSave" />
  </div>
  </q-page>
</template>


<script type="text/babel">
import store from '../store';
import UnitPath from 'components/unit-path.vue';
import RequestCard from 'components/request-card.vue';
import _ from 'lodash';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import SaveBtn from 'components/save-btn.vue';

let nextKey = 0;
const prepareWorks = (works) => {
  const ww = _.cloneDeep(works);
  ww.forEach((a) => {
    a.task = a.task || null;
    a.short = a.short || null;
    a.date = a.date || null;
    a.msDate = a.msDate || Infinity;
    a.key = a.key || (nextKey += 1);
  });
  return ww.sort((a, b) => b.msDate - a.msDate);
};

const squeezeCase = (cc) => {
  delete cc.type;
  delete cc.created;
  delete cc.createdLabel;
  delete cc.label;
  delete cc.link;
  delete cc.status;
  delete cc.workDate;
  delete cc.statusLabel;
  delete cc.tasks;
  return cc;
};

export default {
  name: 'caseedit',
  components: {
    UnitPath,
    RequestCard,
    SaveBtn,
  },
  data() {
    const iniCase = {
      master: '',
      problem: '',
      result: '',
      canceled: false,
    };
    let iniWorks = [];
    if (this.$route.name.indexOf('caseNew') === 0) { // new case
      iniCase.parent_id = this.$route.params.iid;
      // if the only one engineer set him as master
      if (this.$store.getters.engineers.length === 1) {
        iniCase.master = this.$store.getters.engineers[0].value;
      }
    } else {
      Object.assign(iniCase, this.$store.state.cases[this.$route.params.id]);
      delete iniCase.works;
      iniWorks = prepareWorks(this.$store.state.cases[this.$route.params.id].works);
    }
    return {
      newMaster: null,
      addDisabled: false,
      iniCase: _.cloneDeep(iniCase),
      iniWorks: _.cloneDeep(iniWorks),
      tempCase: _.cloneDeep(iniCase),
      tempWorks: _.cloneDeep(iniWorks),
    };
  },
  validations: {
    tempCase: {
      problem: {
        required: withParams({ message: 'Опишите проблему' }, required),
      },
      result: {
        required: withParams({ message: 'Завершенный кейс должен иметь результат' }, requiredIf(function () {
          return this.caseCompleted;
        })),
      },
      master: {
        required: withParams({ message: 'Выберите исполнителя' }, requiredIf(function () {
          return this.caseHasWorks;
        })),
      },
    },
    tempWorks: {
      $each: {
        task: {
          required: withParams({ message: 'Введите цель работы' }, required),
        },
        short: {
          requiredIfCompleted: withParams({ message: 'Хотя бы кратко напишите что сделано' }, requiredIf('completed')),
        },
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter', from);
    if (store.getters.isDispatcher || store.getters.isEngineer) {
      next();
    } else {
      next(from.path);
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave', this && !this.notChanged);
    if (this && !this.notChanged) {
      this.$q.dialog({
        title: 'Внимание',
        'prevent-close': true,
        message: 'При переходе изменения не будут сохранены!',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Перейти',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Остаться',
        },
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  created() {
    if (!this.editEnabled) {
      this.goView();
    }
  },
  mounted() {
    this.$watch('lbl', (a) => {
      document.title = a;
    }, {
      immediate: true,
    });
  },
  watch: {
    tempWorks: {
      deep: true,
      handler(value) {
        let addEnabled = true;
        value.forEach(function (work, index) {
          if (!work.date || work.date === '') {
            // datePicker set '' we need null
            this.tempWorks[index].date = null;
            this.tempWorks[index].msDate = Infinity;
            this.tempWorks[index].completed = false;
          } else {
            this.tempWorks[index].msDate = new Date(work.date).setHours(12, 0, 0, 0);
          }
          // work must has task
          if (!work.task) {
            addEnabled = false;
          }
        }, this);
        this.addDisabled = !addEnabled;
      },
    },
  },
  computed: {
    isDispatcher() {
      return this.$store.getters.isDispatcher;
    },
    editEnabled() {
      return this.isDispatcher || (this.iniCase.master === this.$store.state.user.roles[0]);
    },
    engineers() {
      return this.$store.getters.engineers;
    },
    caseHasWorks() {
      return !_.isEmpty(this.tempWorks);
    },
    caseCompleted() {
      return (
        (!this.tempCase.canceled)
        && !_.isEmpty(this.tempWorks)
        && this.tempWorks.every(work => work.completed)
      );
    },
    needPath() {
      return this.$route.params.filter.indexOf('ins:') !== 0;
    },
    lbl() {
      if (this.addNew) {
        return '*Новый кейс*';
      }
      const createdLabel = this.$utils.id2dateString(this.iniCase._id);
      return `Кейс № ${this.iniCase.num || '????'} от ${createdLabel}`;
    },
    notChanged() {
      return _.isEqual(this.iniCase, this.tempCase) && _.isEqual(this.iniWorks, this.tempWorks);
    },
    id() {
      return this.$route.params.id;
    },
    rid() {
      return this.$route.params.rid;
    },
    filter() {
      return this.$route.params.filter;
    },
    addNew() {
      return (this.$route.name.indexOf('caseNew') === 0);
    },
    fromRequest() {
      return (this.$route.name === 'caseNewFromRequest');
    },
    request() {
      if (this.$route.name === 'caseNewFromRequest') {
        const rid = this.rid;
        return this.$store.state.requests
          .find(item => item._id === rid);
      }
      return this.iniCase.raw;
    },
  },
  methods: {
    setWorkDirty(index) {
      this.$v.tempWorks.$each[index].$touch();
    },
    setCaseDirty() {
      console.log('setCaseDirty');
      this.$v.tempCase.$touch();
    },
    removeWork(index) {
      // const self = this;
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: 'Работа будет удалена!',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Удалить работу',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => {
          this.tempWorks.splice(index, 1);
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    doAdd() {
      this.tempWorks.unshift({
        completed: false,
      });
      this.tempWorks = prepareWorks(this.tempWorks);
    },
    doSave() {
      let requestToSave;
      this.$v.tempCase.$touch();
      this.$v.tempWorks.$touch();
      if (this.$v.tempCase.$invalid || this.$v.tempWorks.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      if (this.addNew) {
        const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        this.tempCase._id = `case:${timestamp}${'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase()}`;
        if (this.request) {
          requestToSave = Object.assign({}, this.request);
          requestToSave.handled = true;
          const requestToRaw = Object.assign({}, this.request);
          delete requestToRaw._id;
          delete requestToRaw._rev;
          this.tempCase.raw = requestToRaw;
        }
      }
      // to notify new master by telegram
      this.newMaster = (this.tempCase.master === this.iniCase.master) ? null : this.tempCase.master;
      // this turn off warning
      Object.assign(this.iniCase, this.tempCase);
      this.iniWorks = _.cloneDeep(this.tempWorks);
      const caseToSave = squeezeCase(this.$copy(this.tempCase));

      console.log('caseToSave', caseToSave);
      caseToSave.works = _.cloneDeep(this.tempWorks);
      delete caseToSave.msDate;
      caseToSave.works.forEach((work) => {
        delete work.key;
        delete work.msDate;
      });
      this.$store.dispatch('saveUnit', caseToSave)
        .then(() => {
          if (requestToSave) {
            return this.$store.dispatch('saveUnit', requestToSave);
          }
          return Promise.resolve(true);
        })
        .then(() => {
          if (this.addNew) {
            this.$store.dispatch('pleaseNumerate');
          }
          if (this.newMaster) {
            this.$store.dispatch('notifyMaster', {
              master: this.newMaster,
              caseId: this.tempCase._id,
            });
          }
          this.$router.jumpBack();
        })
        .catch(() => {
          this.$store.commit('pushError', {
            error: 'Ошибка!',
            message: 'Возможно изменения не сохранены',
          });
          this.goView();
        });
    },
    goView() {
      // this turn off warning -- removed
      // Object.assign(this.iniCase, this.tempCase);
      // this.iniWorks = _.cloneDeep(this.tempWorks);
      this.$router.jumpBack();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/case-edit.vue